import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  bottom: 43px;
  right: 15px;
  width: 340px;
  max-width: calc(100vw - 40px);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  z-index: 1080;

  .floating-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #1f3e4f;
    color: #fff;
    padding: 8px 12px;
  }

  .floating-header .title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 700;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .floating-header .live-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #dc3545;
    flex-shrink: 0;
    animation: pulse 1.4s infinite;
  }

  .floating-header .actions {
    display: flex;
    gap: 4px;
  }

  .floating-header button {
    background: none;
    border: none;
    color: #fff;
    cursor: pointer;
    padding: 2px;
    display: flex;
  }

  .floating-header button .material-icons {
    font-size: 20px;
  }

  .floating-title {
    padding: 8px 12px;
    font-size: 13px;
    color: #333;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }

  @media (max-width: 576px) {
    width: 260px;
  }
`;
